import CircleProfessional from '../../src/legacy/CircleProfessional.tsx';
export default CircleProfessional;
